
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M31 4.076V27.05c0 1.076-.894 1.95-2 1.95-1.104 0-2-.874-2-1.95V5.95C27 4.874 26.106 4 25 4c-1.104 0-2 .874-2 1.95v21.1c0 1.076-.894 1.95-2 1.95-1.104 0-2-.874-2-1.95V5.95C19 4.874 18.106 4 17 4c-1.104 0-2 .874-2 1.95v21.1c0 1.076-.894 1.95-2 1.95-1.104 0-2-.874-2-1.95V5.95C11 4.874 10.106 4 9 4c-1.104 0-2 .874-2 1.95V29M4 11.133l-3-.324v-2.35l3-.326z","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    